package ui.location.detail

import androidx.compose.foundation.*
import androidx.compose.foundation.layout.*
import androidx.compose.foundation.lazy.staggeredgrid.*
import androidx.compose.material3.*
import androidx.compose.runtime.*
import androidx.compose.ui.*
import androidx.compose.ui.draw.*
import androidx.compose.ui.layout.*
import androidx.compose.ui.unit.*
import api.*
import common.frontend.api.*
import compose.assets.*
import compose.assets.svg.*
import ssoft.frontend.generated.resources.*
import tools.*
import ui.resource.*
import ui.widget.*

@Composable
fun LocationScope.LocationEmergency(
    nnvl: LocationScope.Wrapper,
    modifier: Modifier
) {
    val imagePickerKey = remember(args.locationId) {
        "Location:Emergency:${args.locationId}"
    }

    GlobalObjectShare.Consumer(imagePickerKey)

    fun openResourcePicker() {
        GlobalObjectShare.launchImagePicker(
            key = imagePickerKey,
            nav = nav,
            args = ResourceListingArgs(
                companyId = nnvl.data.company.id,
                restrictionType = ResourceType.IMAGE.mask,
            )
        ) {
            it.forEach { item ->
                nnvl.emergency.add(
                    LocationScope.WrapperEmergencyImages.Item(
                        Io.Location.Emergency.Entry(
                            id = item.id,
                            default = false
                        )
                    )
                )
            }
        }
    }

    Box(modifier) {
        LazyVerticalStaggeredGrid(
            columns = StaggeredGridCells.Adaptive(256.dp),
            modifier = Modifier.fillMaxSize(),
            contentPadding = PaddingValues(8.dp),
            verticalItemSpacing = 8.dp,
            horizontalArrangement = Arrangement.spacedBy(8.dp)
        ) {
            items(nnvl.emergency.state.sortedByDescending { it.data.id }) { item ->
                val stateActivation = DialogState.remember()

                ItemActivationDialog(stateActivation, item)

                ImageEntry(
                    item = item,
                    canDelete = nnvl.canEmergencyVisualAdd,
                    onClick = { stateActivation.show() },
                    onDelete = {
                        nnvl.emergency.removeAll { it.key == item.key }
                    })
            }
        }
        if (nnvl.canEmergencyVisualAdd) {
            FloatingActionButton(
                onClick = { openResourcePicker() },
                modifier = Modifier.align(Alignment.BottomEnd)
                    .padding(16.dp)
            ) {
                Icon(Svg.Plus, null)
            }
        }
    }
}

@Composable
fun LocationScope.ItemActivationDialog(state: DialogState, item: LocationScope.WrapperEmergencyImages.Item) {
    Dialog(state) {
        DialogUI(Modifier.align(Alignment.Center),
            onDismissRequest = { state.hide() },
            title = { Text(Res.string.location_detail__emergency_activation_title.rememberString()) },
            confirmButton = {
                TextButton({
                    action(LocationVM.Action.EmergencyActivate(item.data.id))
                    state.hide()
                }) {
                    Text(Res.string.dialog__action_yes.rememberString())
                }
            },
            dismissButton = {
                TextButton({ state.hide() }) {
                    Text(Res.string.dialog__action_no.rememberString())
                }
            }) {
            Column {
                LazyImage(
                    id = item.data.id,
                    modifier = Modifier.size(256.dp),
                    alphaBackground = false
                )
                Space(16.dp)
                Text(Res.string.location_detail__emergency_activation_desc.rememberString())
            }
        }
    }
}


@Composable
private fun ImageEntry(
    item: LocationScope.WrapperEmergencyImages.Item,
    canDelete: Boolean,
    onClick: () -> Unit,
    onDelete: (() -> Unit)? = null
) {
    Box(Modifier.size(256.dp)) {
        LazyImage(
            id = item.data.id,
            modifier = Modifier.fillMaxWidth()
                .clickable { onClick() },
            contentScale = ContentScale.Crop,
            alphaBackground = false
        )
        onDelete
            ?.takeIf { !item.data.default }
            ?.takeIf { canDelete }
            ?.also { action ->
                IconButton(
                    onClick = { action() },
                    colors = IconButtonDefaults.iconButtonColors(
                        containerColor = MaterialTheme.colorScheme.surface,
                    ),
                    modifier = Modifier.padding(8.dp)
                        .alpha(0.8F)
                        .align(Alignment.TopCenter)
                ) {
                    Icon(Svg.DeleteEmpty, null)
                }
            }
    }
}
